(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/oddset/quick-bets/assets/javascripts/common/utils.js') >= 0) return;  svs.modules.push('/components/oddset/quick-bets/assets/javascripts/common/utils.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  BetOfferTypeId
} = svs.components.oddset.kambiOffering.common.constants;
const {
  getOddsetBetslipQueryString
} = svs.components.oddset.common.utils;
const buildBetOfferKey = outcomes => outcomes.reduce((acc, outcome) => "".concat(acc, "-").concat(outcome.id), '');
const byLine = (a, b) => {
  const lineA = a.outcomes[0].line;
  const lineB = b.outcomes[0].line;
  if (lineA > lineB) {
    return 1;
  }
  if (lineA < lineB) {
    return -1;
  }
  return 0;
};
const byHomeScore = (a, b) => a.homeScore - b.homeScore || a.awayScore - b.awayScore;
const byAwayScore = (a, b) => a.awayScore - b.awayScore || a.homeScore - b.homeScore;
const groupResultOutcomes = outcomes => {
  const homeWin = outcomes.filter(outcome => parseInt(outcome.homeScore, 10) > parseInt(outcome.awayScore, 10)).sort(byHomeScore);
  const awayWin = outcomes.filter(outcome => parseInt(outcome.homeScore, 10) < parseInt(outcome.awayScore, 10)).sort(byAwayScore);
  const evenScores = outcomes.filter(outcome => parseInt(outcome.homeScore, 10) === parseInt(outcome.awayScore, 10)).sort(byHomeScore);
  return {
    homeWin,
    awayWin,
    evenScores
  };
};
const splitBetOffers = betOffersArr => betOffersArr.reduce((acc, betOffer) => {
  if (betOffer.type === BetOfferTypeId.Result) {
    const {
      homeWin,
      awayWin,
      evenScores
    } = groupResultOutcomes(betOffer.outcomes);
    const numberOfBetOffers = Math.max(homeWin.length, awayWin.length, evenScores.length);
    const splitOffers = [...Array(numberOfBetOffers).keys()].map((_, i) => {
      const outcomes = [];
      if (homeWin[i]) {
        outcomes.push(homeWin[i]);
      } else {
        outcomes.push({
          id: "home-".concat(i),
          placeholder: true
        });
      }
      if (evenScores[i]) {
        outcomes.splice(1, 0, evenScores[i]);
      } else {
        outcomes.push({
          id: "even-".concat(i),
          placeholder: true
        });
      }
      if (awayWin[i]) {
        outcomes.push(awayWin[i]);
      } else {
        outcomes.push({
          id: "away-".concat(i),
          placeholder: true
        });
      }
      return _objectSpread(_objectSpread({}, betOffer), {}, {
        key: buildBetOfferKey(outcomes),
        outcomes
      });
    });
    acc.push(...splitOffers);
    return acc;
  }
  acc.push(betOffer);
  return acc;
}, []);
const removeDuplicates = arr => [...new Set(arr)];
const sortOffers = (betOfferArr, betOfferType) => {
  if (betOfferType === BetOfferTypeId.OverUnder || betOfferType === BetOfferTypeId.Handicap) {
    return betOfferArr.sort(byLine);
  }
  return betOfferArr;
};

const trackSportbookEvent = trackingLabel => {
  svs.components.analytics.trackEvent({
    category: 'Navigation',
    action: 'my-bets-oddset',
    opt_label: trackingLabel
  });
};

const getNavigateLinkToSportbook = _ref => {
  let {
    path,
    outcomeId
  } = _ref;
  if (outcomeId) {
    path += getOddsetBetslipQueryString(outcomeId);
  }
  return path;
};
setGlobal('svs.components.oddset.quickBets.common.utils', {
  removeDuplicates,
  sortOffers,
  getNavigateLinkToSportbook,
  trackSportbookEvent,
  splitBetOffers
});

 })(window);